// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
  width: 100%;
}

.login-form__field {
  margin-bottom: 16px;
}

.login-form__actions {
  margin-top: 24px;
}

.email-input {
  text-transform: lowercase;
}

.input-item.has-error {
  border-color: var(--input-error-color) !important;
  box-shadow: 0 0 0 1px var(--input-error-color);
}

.input-item.is-valid {
  border-color: var(--input-success-color) !important;
}

.validation-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2em;
  z-index: 2;
  animation: checkPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.validation-icon.is-valid {
  color: var(--input-success-color);
}

.validation-icon.has-error {
  color: var(--input-error-color);
}

.custom-logo {
  width: 200px;
  margin: 0 auto;
  display: block;
}

.login-subtitle,
.input-label-text {
  color: #908B99;
}

.not-have-acc {
  position: absolute;
  bottom: 10px;
  text-decoration: none;
}

.timer {
  margin-top: 10px;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: bold;
  text-align: center;
}

.custom-input {
  color: var(--label-login-color);
  padding-left: 10px !important;
  height: 3rem;
  margin: auto;
  display: inline;
  border-radius: 5px;
}

.custom-btn {
  color: rgba(0, 0, 0, 0.65);
  background: #ffffff;
  height: 41px;
  width: 100%;
}

.login-text {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
  font-size: 1.2em;
}

.login-btn {
  color: #000000;
  font-weight: 300;
  height: 38px;
  font-size: 1em;
  border-radius: 5px;
  padding: 10px;
}

.forgot-password {
  font-size: 14px;
  padding-left: 3px;
  text-decoration: underline;
  font-family: "Roobert-Regular";
  cursor: pointer;
}

.invalid-code {
  font-size: 0.8em;
  color: #dd2222;
  font-weight: bold;
  text-align: center;
  margin: 4px 0 0;
  font-family: "Roobert-Regular";
}

.term-conditions {
  background-color: transparent;
  border: none;
  font-size: 0.78em;
  display: flex;
  align-items: center;
}

.footer {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
}

.footer-txt {
  font-size: 0.7em;
}

.spinner svg {
  width: 16px !important;
  height: 16px !important;
}

.text-center {
  text-align: center;
}

.btn-default {
  height: 3rem;
  width: 100%;
  max-width: none;
  font-family: "Roobert-Bold";
}

.btn-default .align-loader {
  min-height: 0;
  margin: 0;
}

ion-checkbox {
  width: 33px;
  height: 21px;
  --border-radius: 4px;
}

.code-label {
  display: block;
  font-family: "Roobert-Regular";
  font-size: 0.85em;
  color: var(--label-login-color);
  margin-bottom: 12px;
}

.code-digit-row {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 16px;
}

.code-digit-input {
  width: 48px;
  height: 56px;
  text-align: center;
  font-family: "Roobert-Bold";
  font-size: 1.4em;
  border: 1.5px solid var(--input-border-color);
  border-radius: var(--border-radius-md);
  background: var(--input-bg);
  color: var(--text-color-2nd-login-desktop);
  transition: border-color var(--transition-normal), box-shadow var(--transition-normal);
  outline: none;
  -moz-appearance: textfield;
}

.code-digit-input::-webkit-outer-spin-button,
.code-digit-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.code-digit-input:focus {
  border-color: var(--input-focus-border-color);
  box-shadow: 0 0 0 3px rgba(41, 115, 162, 0.12);
}

.code-digit-input.filled {
  border-color: var(--input-focus-border-color);
  background: rgba(41, 115, 162, 0.04);
}

.code-digit-input.has-error {
  border-color: var(--input-error-color);
}

.code-digit-input.has-error:focus {
  box-shadow: 0 0 0 3px rgba(240, 65, 65, 0.12);
}

.color-1st-screen .code-label {
  color: rgba(255, 255, 255, 0.8);
}

.color-1st-screen .code-digit-input {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.3);
  color: #ffffff;
}

.color-1st-screen .code-digit-input:focus {
  border-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
}

.color-1st-screen .code-digit-input.filled {
  border-color: rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.18);
}

.color-1st-screen .forgot-password {
  color: rgba(255, 255, 255, 0.85);
}

@media screen and (min-width: 768px) {
  .forgot-password {
    color: var(--text-color-2nd-login-desktop);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/login-with-code-confirm/login-with-code-confirm.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,iDAAA;EACA,8CAAA;AACF;;AAEA;EACE,mDAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,mEAAA;AACF;;AAEA;EACE,iCAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,+BAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,0BAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,8BAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,8BAAA;AACF;;AAEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,8BAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,6CAAA;EACA,sCAAA;EACA,2BAAA;EACA,0CAAA;EACA,sFAAA;EACA,aAAA;EACA,0BAAA;AACF;;AAEA;;EAEE,wBAAA;EACA,SAAA;AACF;;AAEA;EACE,6CAAA;EACA,8CAAA;AACF;;AAEA;EACE,6CAAA;EACA,oCAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,qCAAA;EACA,sCAAA;EACA,cAAA;AACF;;AAEA;EACE,sCAAA;EACA,8CAAA;AACF;;AAEA;EACE,sCAAA;EACA,qCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE;IACE,0CAAA;EACF;AACF","sourcesContent":[".login-form {\n  width: 100%;\n}\n\n.login-form__field {\n  margin-bottom: 16px;\n}\n\n.login-form__actions {\n  margin-top: 24px;\n}\n\n.email-input {\n  text-transform: lowercase;\n}\n\n.input-item.has-error {\n  border-color: var(--input-error-color) !important;\n  box-shadow: 0 0 0 1px var(--input-error-color);\n}\n\n.input-item.is-valid {\n  border-color: var(--input-success-color) !important;\n}\n\n.validation-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.2em;\n  z-index: 2;\n  animation: checkPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n\n.validation-icon.is-valid {\n  color: var(--input-success-color);\n}\n\n.validation-icon.has-error {\n  color: var(--input-error-color);\n}\n\n.custom-logo {\n  width: 200px;\n  margin: 0 auto;\n  display: block;\n}\n\n.login-subtitle,\n.input-label-text {\n  color: #908B99;\n}\n\n.not-have-acc {\n  position: absolute;\n  bottom: 10px;\n  text-decoration: none;\n}\n\n.timer {\n  margin-top: 10px;\n  font-size: .8em;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n  text-align: center;\n}\n\n.custom-input {\n  color: var(--label-login-color);\n  padding-left: 10px !important;\n  height: 3rem;\n  margin: auto;\n  display: inline;\n  border-radius: 5px;\n}\n\n.custom-btn {\n  color: rgba(0, 0, 0, 0.65);\n  background: #ffffff;\n  height: 41px;\n  width: 100%;\n}\n\n.login-text {\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 1.2em;\n}\n\n.login-btn {\n  color: #000000;\n  font-weight: 300;\n  height: 38px;\n  font-size: 1em;\n  border-radius: 5px;\n  padding: 10px;\n}\n\n.forgot-password {\n  font-size: 14px;\n  padding-left: 3px;\n  text-decoration: underline;\n  font-family: 'Roobert-Regular';\n  cursor: pointer;\n}\n\n.invalid-code {\n  font-size: 0.8em;\n  color: #dd2222;\n  font-weight: bold;\n  text-align: center;\n  margin: 4px 0 0;\n  font-family: 'Roobert-Regular';\n}\n\n.term-conditions {\n  background-color: transparent;\n  border: none;\n  font-size: .78em;\n  display: flex;\n  align-items: center;\n}\n\n.footer {\n  width: 100%;\n  text-align: center;\n  position: absolute;\n  bottom: 0;\n}\n\n.footer-txt {\n  font-size: .7em;\n}\n\n.spinner svg {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.btn-default {\n  height: 3rem;\n  width: 100%;\n  max-width: none;\n  font-family: 'Roobert-Bold';\n}\n\n.btn-default .align-loader {\n  min-height: 0;\n  margin: 0;\n}\n\nion-checkbox {\n  width: 33px;\n  height: 21px;\n  --border-radius: 4px;\n}\n\n.code-label {\n  display: block;\n  font-family: 'Roobert-Regular';\n  font-size: 0.85em;\n  color: var(--label-login-color);\n  margin-bottom: 12px;\n}\n\n.code-digit-row {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.code-digit-input {\n  width: 48px;\n  height: 56px;\n  text-align: center;\n  font-family: 'Roobert-Bold';\n  font-size: 1.4em;\n  border: 1.5px solid var(--input-border-color);\n  border-radius: var(--border-radius-md);\n  background: var(--input-bg);\n  color: var(--text-color-2nd-login-desktop);\n  transition: border-color var(--transition-normal), box-shadow var(--transition-normal);\n  outline: none;\n  -moz-appearance: textfield;\n}\n\n.code-digit-input::-webkit-outer-spin-button,\n.code-digit-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.code-digit-input:focus {\n  border-color: var(--input-focus-border-color);\n  box-shadow: 0 0 0 3px rgba(41, 115, 162, 0.12);\n}\n\n.code-digit-input.filled {\n  border-color: var(--input-focus-border-color);\n  background: rgba(41, 115, 162, 0.04);\n}\n\n.code-digit-input.has-error {\n  border-color: var(--input-error-color);\n}\n\n.code-digit-input.has-error:focus {\n  box-shadow: 0 0 0 3px rgba(240, 65, 65, 0.12);\n}\n\n.color-1st-screen .code-label {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.color-1st-screen .code-digit-input {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: #ffffff;\n}\n\n.color-1st-screen .code-digit-input:focus {\n  border-color: rgba(255, 255, 255, 0.7);\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);\n}\n\n.color-1st-screen .code-digit-input.filled {\n  border-color: rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.color-1st-screen .forgot-password {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n@media screen and (min-width: 768px) {\n  .forgot-password {\n    color: var(--text-color-2nd-login-desktop);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
